import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import { createContent, buildContent } from '../../../../map/commonFunctions'
import { createInfoContent } from './infoWindow'
import { expandLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { infoWindowOpenAction } from '../../../../../action/infowindow-action'

const ShareMarker = (props) => {
    const [work, setWork] = useState(false)
    const [previousState, setPreviousState] = useState(null)
    const [infowindowsState, setInfowindowsState] = useState(null)
    const { expandLeftToolbar, infoWindowOpenAction, infoWindow } = props
    // const history = useHistory();
    const history = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const glatitude = urlParams.get('latitude');
    const glongitude = urlParams.get('longitude');
    const nValue = urlParams.get('n');
    const cValue = urlParams.get('c');
    let mapObj = null
    let openInfoWindow = null;
    let token = props.auth.token

    useEffect(() => {
        setWork(true)
    }, [props.mapReference])

    useEffect(() => {
        const getParamsFromURL = () => {
            let coords = new google.maps.LatLng(glatitude, glongitude)
            if (props.mapReference && glatitude && glongitude) {
                props.mapReference.setCenter(coords)
                props.mapReference.setZoom(12)
                const newSearch = new URLSearchParams(window.location.search);
                newSearch.delete('latitude');
                newSearch.delete('longitude');
                newSearch.delete('t');
                newSearch.delete('n');
                newSearch.delete('c');
                history.replace({
                    pathname: window.location.pathname,
                    search: newSearch.toString(),
                });
            }
        };
        getParamsFromURL();
    }, [props.mapReference]);

    useEffect(() => {
        if (infoWindow && infoWindow.infoWindowFunction) {
            infoWindow.infoWindowFunction.close()
        }
        setPreviousState(infowindowsState);
        infoWindowOpenAction(infowindowsState)
        checkAndClose()
    }, [infowindowsState])

    useEffect(() => {
        // let decodedNValue = cValue ? decodeURIComponent(decodedNValue).split(' ')[0] : null;
        const decodedNValue = encodeURIComponent(cValue);
        let url = `https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/${decodedNValue}.svg`;
        const img = new Image();
        img.src = url;
        let color = '9ECC3B';
        img.onload = () => {
            if (props.mapReference && glatitude && glongitude) {
                createMarker(props.mapReference, url, color);
            }
        };
        img.onerror = () => {
            url = 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg';
            if (props.mapReference && glatitude && glongitude) {
                createMarker(props.mapReference, url, color);
            }
        };
    }, [props.mapReference]);

    let storeInfoBox = (value) => {
        setInfowindowsState(value);
        infoWindowOpenAction(value)
    }

    let checkAndClose = () => {
        if (previousState) {
            previousState.close()
        }
    }

    let createMarker = async (mapReference, url, color) => {
        if (glatitude && glongitude) {
            let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
            mapObj = new AdvancedMarkerElement({
                map: mapReference,
                content: buildContent(url, color),
                position: { lat: parseFloat(glatitude), lng: parseFloat(glongitude) },
                title: nValue,
            })
            let marker = { id: 1, latitude: glatitude, color: color, longitude: glongitude, name: nValue, markerType: { vectorIconUrl: url }, SharedMarker: true, markerName: nValue }
            marker['measureType'] = 'marker'
            marker['mapObj'] = function () { return mapObj }

            const handleClick = (createContent) => {
                let deleteFunction = () => {
                    mapObj.map = null
                }
                const closeFunction = (infoWindow) => {
                    openInfoWindow = infoWindow;
                    openInfoWindow.close();
                    // infoWindowOpenAction(null)
                    // mapReference.setZoom(4)
                    setInfowindowsState(null)
                }

                const editFunction = (infoWindow) => {
                    expandLeftToolbar({ dialog: 'edit', editable: marker, mapObj: mapListner })
                    openInfoWindow = infoWindow;
                    openInfoWindow && openInfoWindow.close();
                    // infoWindowOpenAction(null)
                    // clickListnerRef.current = clickOnMarker
                    // markerData.current = mapObj
                    // google.maps.event.removeListener(secondClick.current);
                    // google.maps.event.removeListener(mapListner);
                    mapReference.setCenter({ lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) })
                    mapReference.setZoom(17)
                }
                // editFunction(infoWindow)
                const updateInfoWindow = (value) => {
                    openInfoWindow = value
                }
                const dispatchFunction = (value) => {
                    storeInfoBox(value)
                }
                if (createContent) {
                    createInfoContent({ mapReference, mapObj, marker, infoWindow, openInfoWindow, token }, { deleteFunction, closeFunction, editFunction, updateInfoWindow }, dispatchFunction)
                }
                if (!createContent) {
                    editFunction(infoWindow)
                }
            }
            let mapListner = mapObj.addListener('click', () => handleClick(true));
            handleClick(false);
        }
    }

    return (
        <div>
            {/* {work && <MarkerDetails sharedMarker={true}></MarkerDetails>} */}
        </div>
    )
}
const mapStateToProps = state => ({
    featureFields: state.featureFields,
    token: state.auth.token,
    loading: state.loading,
    leftToolbarState: state.leftToolbarState,
    rightToolbarState: state.rightToolbarState,
    layersDictionary: state.layersDictionary,
    userPreferences: state.userPreferences,
    featuresBlocked: state.featuresBlocked,
    mapReference: state.mapReference(),
    infoWindow: state.infoWindow,
    auth: state.auth,
})

const mapDispatchToProps = dispatch => ({
    expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
    infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload))
    // fetchFeatureInfoFields: id => dispatch(fetchFeatureInfoFields(id)),
    // setMapReference: map => dispatch(setMapReference(map))
})

export default connect(mapStateToProps, mapDispatchToProps)(ShareMarker)
